// Bilingual FR / AR translations for Ssuq marketplace
export const translations = {
  fr: {
    dir: "ltr",
    nav_catalogue: "Catalogue",
    nav_vendre: "Vendre sur Ssuq",
    nav_admin: "Admin",
    nav_contact: "Contact",
    nav_compte: "Compte pro",
    nav_connexion: "Se connecter",

    hero_badge: "Marketplace B2B — Algérie",
    hero_title_1: "Le gros alimentaire,",
    hero_title_2: "en direct.",
    hero_sub: "Ssuq connecte producteurs et importateurs aux professionnels de la restauration, de l'alimentation, des supermarchés et de la pâtisserie — au prix du gros, partout en Algérie.",
    hero_cta_1: "Voir le catalogue",
    hero_cta_2: "Devenir client pro",
    hero_quote: "« Du producteur à votre cuisine. »",
    hero_quote_sub: "Nos partenaires professionnels",

    stat_b2b: "réservé aux professionnels",
    stat_delay: "livraison en 48–72h",
    stat_vendors: "producteurs & importateurs",

    marquee: ["Prix du gros", "Producteurs vérifiés", "Livraison 48–72h", "Client vérifié", "0 commission sur la vente", "Partout en Algérie"],

    manifesto_label: "Notre mission",
    manifesto_title: "Trois engagements, une seule exigence : que votre commerce ne s'arrête jamais.",
    engage: [
      { n: "01", t: "Vente directe", d: "Producteurs et importateurs vendent sans intermédiaire. Vous achetez au prix réel du gros, avec une traçabilité complète de la source à votre commerce." },
      { n: "02", t: "Tous secteurs", d: "Épicerie, boissons, frais, surgelés, pâtisserie et emballages — tout l'approvisionnement de votre établissement au même endroit." },
      { n: "03", t: "Logistique maîtrisée", d: "Livraison partout en Algérie entre 48h et 72h, chaîne du froid respectée et suivi de commande en temps réel." }
    ],

    cat_label: "Le catalogue en un regard",
    cat_all: "Tout parcourir",
    cat_see: "Voir les références",
    feat_label: "Sélection du moment",
    feat_title: "Produits en vedette",
    feat_cta: "Tout le catalogue",
    promo_label: "En promotion",
    promo_title: "Offre du mois sur les boissons",
    promo_sub: "Prima et Hamoud Boualem à prix cassés pour les professionnels. Stocks limités, commandez vite.",
    promo_badge: "Jusqu'à -15%",
    promo_cta: "Profiter de l'offre",
    ad_cta: "Voir l'offre",
    ad_danone_t: "Danone Yomi",
    ad_danone_s: "Tous les bienfaits du lait — pack de 24 pots, tarif pro.",
    ad_hamoud_t: "Hamoud Boualem",
    ad_hamoud_s: "Selecto, Hamoud Cola & Slim — offre pro jusqu'à -15%.",

    deliv_label: "Livraison",
    deliv_title: "Trois circuits, une seule commande.",
    deliv_sub: "Commandez tout au même endroit : nous dispatchons par circuit température. Livraison partout en Algérie entre 48h et 72h, du dimanche au jeudi.",
    deliv_items: [
      { n: "01", t: "Produits secs", d: "Épicerie, épices, conserves et boissons — livraison classique." },
      { n: "02", t: "Produits frais", d: "Viandes, volailles et fromages — chaîne du froid 0–4 °C." },
      { n: "03", t: "Surgelés", d: "Frites, panés, légumes — transport à -18 °C garanti." }
    ],
    deliv_cta: "Ouvrir un compte pro",

    vendor_label: "Producteurs & Importateurs",
    vendor_title: "Vendez directement aux professionnels.",
    vendor_sub: "Publiez votre catalogue, fixez vos prix du gros et vos quantités minimales, et touchez des milliers de restaurants, épiceries et supermarchés partout en Algérie.",
    vendor_points: ["Zéro commission d'inscription", "Vos prix, vos conditions", "Paiements sécurisés & factures", "Tableau de bord des commandes"],
    vendor_cta: "Devenir vendeur",

    cta_title: "Prêt à commander au prix du gros ?",
    cta_sub: "Créez votre compte professionnel en deux minutes. Paiement sécurisé, facture officielle immédiate.",
    cta_1: "Créer mon compte pro",
    cta_2: "Explorer le catalogue",

    catalogue_label: "Catalogue B2B",
    catalogue_title: "Nos références",
    catalogue_sub: "Prix hors taxes, par unité de vente. Quantités minimales de commande (MOQ) indiquées sur chaque produit.",
    filter_all: "Tous",
    references: "références",
    reference: "référence",
    search_ph: "Rechercher un produit, une marque…",
    add: "Ajouter",
    added: "Ajouté",
    moq: "MOQ",
    ht_unit: "HT / ",
    ttc: "TTC",
    by: "par",
    empty: "Aucun produit ne correspond à votre recherche.",

    cart_title: "Mon panier",
    cart_empty: "Votre panier est vide.",
    cart_empty_sub: "Parcourez le catalogue pour ajouter des produits.",
    cart_total_ht: "Total HT",
    cart_tva: "TVA (19%)",
    cart_total_ttc: "Total TTC",
    cart_checkout: "Passer la commande",
    cart_continue: "Continuer mes achats",
    remove: "Retirer",
    min: "min.",

    signup_label: "Réservé aux professionnels",
    signup_title: "Compte pro",
    f_company: "Raison sociale",
    f_activity: "Type d'activité",
    f_contact: "Nom du responsable",
    f_email: "E-mail professionnel",
    f_phone: "Téléphone",
    f_wilaya: "Wilaya",
    f_address: "Adresse complète du point de vente",
    f_rc: "N° Registre de commerce",
    f_password: "Mot de passe",
    f_select: "Sélectionner…",
    signup_consent: "J'accepte les Conditions Générales de Vente et la Politique de confidentialité.",
    signup_btn: "Créer mon compte pro",
    already: "Déjà inscrit ?",
    signin: "Se connecter",
    signup_ok: "Demande envoyée ✔ Après validation par notre équipe, vous recevrez votre code client par e-mail.",

    login_title: "Connexion",
    login_sub: "Accédez à votre compte professionnel.",
    login_code: "Code client (reçu par e-mail)",
    login_btn: "Se connecter",
    no_account: "Pas encore de compte ?",
    create_account: "Créer un compte pro",
    login_ok: "Connexion réussie (démo).",
    price_locked: "Prix réservé aux pros",
    login_to_price: "Se connecter pour voir le prix",
    my_selection: "Ma sélection",
    sector_pick: "Sélection par activité",

    seller_label: "Espace vendeur",
    seller_title: "Vendre sur Ssuq",
    seller_sub: "Rejoignez le réseau des producteurs et importateurs. Publiez vos produits en quelques minutes.",
    f_type: "Vous êtes",
    opt_prod: "Producteur",
    opt_imp: "Importateur",
    f_cats: "Catégories proposées",
    seller_btn: "Rejoindre Ssuq",
    seller_ok: "Demande envoyée (démo). Notre équipe vous contactera.",

    footer_tag: "La marketplace B2B des professionnels de l'alimentaire en Algérie.",
    footer_nav: "Navigation",
    footer_legal: "Informations",
    footer_contact: "Contact",
    footer_rights: "Tous droits réservés.",
    whatsapp: "Une question ? Écrivez-nous",
    currency: "DA"
  },

  ar: {
    dir: "rtl",
    nav_catalogue: "الكتالوج",
    nav_vendre: "البيع على سوق",
    nav_admin: "الإدارة",
    nav_contact: "اتصل بنا",
    nav_compte: "حساب محترف",
    nav_connexion: "تسجيل الدخول",

    hero_badge: "سوق B2B — الجزائر",
    hero_title_1: "الجملة الغذائية،",
    hero_title_2: "مباشرة.",
    hero_sub: "يربط سوق المنتجين والمستوردين بمحترفي المطاعم والمواد الغذائية والمتاجر الكبرى والحلويات — بسعر الجملة، في كل أنحاء الجزائر.",
    hero_cta_1: "تصفّح الكتالوج",
    hero_cta_2: "كن زبوناً محترفاً",
    hero_quote: "« من المنتج إلى مطبخك. »",
    hero_quote_sub: "شركاؤنا المحترفون",

    stat_b2b: "مخصص للمحترفين",
    stat_delay: "التوصيل في 48–72 ساعة",
    stat_vendors: "منتجون ومستوردون",

    marquee: ["سعر الجملة", "منتجون موثوقون", "توصيل 48–72 ساعة", "زبون موثّق", "0 عمولة على البيع", "في كل أنحاء الجزائر"],

    manifesto_label: "مهمتنا",
    manifesto_title: "ثلاثة التزامات، ومطلب واحد: ألا يتوقف نشاطك أبداً.",
    engage: [
      { n: "01", t: "بيع مباشر", d: "يبيع المنتجون والمستوردون دون وسيط. تشتري بسعر الجملة الحقيقي، مع تتبّع كامل من المصدر إلى متجرك." },
      { n: "02", t: "كل القطاعات", d: "بقالة، مشروبات، طازج، مجمدات، حلويات وتغليف — كل تموين مؤسستك في مكان واحد." },
      { n: "03", t: "لوجستيك محكم", d: "توصيل في كل أنحاء الجزائر بين 48 و72 ساعة، مع احترام سلسلة التبريد وتتبّع الطلب مباشرة." }
    ],

    cat_label: "الكتالوج بلمحة",
    cat_all: "تصفّح الكل",
    cat_see: "عرض المنتجات",
    feat_label: "اختيار اللحظة",
    feat_title: "منتجات مختارة",
    feat_cta: "كل الكتالوج",
    promo_label: "في التخفيض",
    promo_title: "عرض الشهر على المشروبات",
    promo_sub: "بريما وحمود بولعلام بأسعار مخفّضة للمحترفين. الكميات محدودة، اطلب بسرعة.",
    promo_badge: "حتى -15%",
    promo_cta: "استفد من العرض",
    ad_cta: "شاهد العرض",
    ad_danone_t: "دانون يومي",
    ad_danone_s: "كل فوائد الحليب — حزمة من 24 عبوة، سعر المحترفين.",
    ad_hamoud_t: "حمود بولعلام",
    ad_hamoud_s: "سيلكتو، حمود كولا وسليم — عرض للمحترفين حتى -15%.",

    deliv_label: "التوصيل",
    deliv_title: "ثلاثة مسارات، طلب واحد.",
    deliv_sub: "اطلب كل شيء من مكان واحد: نوزّع حسب مسار درجة الحرارة. توصيل في كل أنحاء الجزائر بين 48 و72 ساعة، من الأحد إلى الخميس.",
    deliv_items: [
      { n: "01", t: "مواد جافة", d: "بقالة، توابل، معلبات ومشروبات — توصيل عادي." },
      { n: "02", t: "منتجات طازجة", d: "لحوم، دواجن وأجبان — سلسلة تبريد 0–4°." },
      { n: "03", t: "مجمدات", d: "بطاطا، مقرمشات، خضر — نقل عند -18° مضمون." }
    ],
    deliv_cta: "فتح حساب محترف",

    vendor_label: "المنتجون والمستوردون",
    vendor_title: "بِع مباشرةً للمحترفين.",
    vendor_sub: "انشر كتالوجك، حدّد أسعار الجملة والكميات الدنيا، وصِل إلى آلاف المطاعم والبقالات والمتاجر الكبرى في كل أنحاء الجزائر.",
    vendor_points: ["صفر عمولة تسجيل", "أسعارك وشروطك", "مدفوعات آمنة وفواتير", "لوحة تحكّم الطلبات"],
    vendor_cta: "كن بائعاً",

    cta_title: "جاهز للطلب بسعر الجملة؟",
    cta_sub: "أنشئ حسابك المحترف في دقيقتين. دفع آمن وفاتورة رسمية فورية.",
    cta_1: "إنشاء حساب محترف",
    cta_2: "استكشاف الكتالوج",

    catalogue_label: "كتالوج B2B",
    catalogue_title: "منتجاتنا",
    catalogue_sub: "الأسعار خارج الرسوم، حسب وحدة البيع. الكميات الدنيا للطلب (MOQ) مذكورة على كل منتج.",
    filter_all: "الكل",
    references: "منتجات",
    reference: "منتج",
    search_ph: "ابحث عن منتج أو علامة…",
    add: "أضف",
    added: "أُضيف",
    moq: "الحد الأدنى",
    ht_unit: "خارج الرسوم / ",
    ttc: "شامل الرسوم",
    by: "من",
    empty: "لا يوجد منتج مطابق لبحثك.",

    cart_title: "سلّتي",
    cart_empty: "سلّتك فارغة.",
    cart_empty_sub: "تصفّح الكتالوج لإضافة منتجات.",
    cart_total_ht: "المجموع خارج الرسوم",
    cart_tva: "الرسم (19%)",
    cart_total_ttc: "المجموع شامل الرسوم",
    cart_checkout: "إتمام الطلب",
    cart_continue: "مواصلة التسوّق",
    remove: "إزالة",
    min: "الأدنى",

    signup_label: "مخصص للمحترفين",
    signup_title: "حساب محترف",
    f_company: "الاسم التجاري",
    f_activity: "نوع النشاط",
    f_contact: "اسم المسؤول",
    f_email: "البريد المهني",
    f_phone: "الهاتف",
    f_wilaya: "الولاية",
    f_address: "العنوان الكامل لنقطة البيع",
    f_rc: "رقم السجل التجاري",
    f_password: "كلمة المرور",
    f_select: "اختر…",
    signup_consent: "أوافق على الشروط العامة للبيع وسياسة الخصوصية.",
    signup_btn: "إنشاء حسابي المحترف",
    already: "مسجّل مسبقاً؟",
    signin: "تسجيل الدخول",
    signup_ok: "تم إرسال الطلب ✔ بعد التحقق من طرف فريقنا ستستلم رمز الزبون عبر البريد الإلكتروني.",

    login_title: "تسجيل الدخول",
    login_sub: "ادخل إلى حسابك المحترف.",
    login_code: "رمز الزبون (المُستلَم عبر البريد)",
    login_btn: "دخول",
    no_account: "ليس لديك حساب؟",
    create_account: "إنشاء حساب محترف",
    login_ok: "تم تسجيل الدخول (تجريبي).",
    price_locked: "الأسعار للمحترفين فقط",
    login_to_price: "سجّل الدخول لرؤية السعر",
    my_selection: "اختياري",
    sector_pick: "اختيار حسب النشاط",

    seller_label: "فضاء البائع",
    seller_title: "البيع على سوق",
    seller_sub: "انضم إلى شبكة المنتجين والمستوردين. انشر منتجاتك في دقائق.",
    f_type: "أنت",
    opt_prod: "منتج",
    opt_imp: "مستورد",
    f_cats: "الفئات المقترحة",
    seller_btn: "انضم إلى سوق",
    seller_ok: "تم إرسال الطلب (تجريبي). سيتصل بك فريقنا.",

    footer_tag: "سوق B2B لمحترفي القطاع الغذائي في الجزائر.",
    footer_nav: "التصفّح",
    footer_legal: "معلومات",
    footer_contact: "اتصل بنا",
    footer_rights: "جميع الحقوق محفوظة.",
    whatsapp: "لديك سؤال؟ راسلنا",
    currency: "دج"
  }
};
